import React from 'react';
import _ from 'lodash';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { format } from '../../../../../common/services/common.service';

export const NPSubscriptionDetailsInfoComponent = ({ businessDetails }: any) => {
    return (
        <>
            <AccordionContainer
                child={
                    <div className="h-auto w-full bg-white p-2 rounded overflow-y-auto">
                        <table className="w-full text-xs bg-red-50">
                            <thead className="w-full border-y border-black border-opacity-20">
                                <tr className="w-full text-left h-12">
                                    <th className="px-3">S.NO</th>
                                    <th className="px-3">NPSubscription Name</th>
                                    <th className="px-3">License Id</th>
                                    <th className="px-3">Organization Id</th>
                                    <th className="px-3">Total No Of DBaaSSubscriptions</th>
                                    <th className="px-3">CreatedOnUtc</th>
                                    <th className="px-3">ModifiedOnUtc</th>
                                </tr>
                            </thead>
                            <tbody className="w-full h-auto">
                                {businessDetails?.NPSubscriptions?.map((ProductsItems: any, index: any) => (
                                    <tr key={index} className="cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white">
                                        <td className="px-3">{index + 1}</td>
                                        <td className="px-3">{ProductsItems?.NPSubscriptionName}</td>
                                        <td className="px-3">{ProductsItems?.LicenseId}</td>
                                        <td className="px-3">{ProductsItems?.OrganizationUnitId}</td>
                                        <td className="px-3">{ProductsItems?.TotalNoOfDBaaSSubscriptions}</td>
                                        <td className="px-3">{format(ProductsItems?.CreatedOnUtc)}</td>
                                        <td className="px-3">{format(ProductsItems?.ModifiedOnUtc)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                }
                expandedPanel="NPSubscription Info"
                headerTitle="NPSubscription Info"

            />

        </>
    )
}
export default NPSubscriptionDetailsInfoComponent;